<!-- Icono on:hover para mostrar información adicional en un card -->
<template>
  <v-menu open-on-hover offset-x right :nudge-bottom="20" :nudge-left="16" :close-on-content-click="false" :close-on-click="true">
    <template v-slot:activator="{ on }">
      <v-icon style="cursor: pointer;" :color="iconColor" v-on="on">{{ prependIcon }}</v-icon>
    </template>
    <v-card class="px-2 py-1" :max-width="width" @click.native="{}">
      <v-card-text class="black--text body-2">
        <slot name="contenido"></slot>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'CardToolTip',
  props: {
    prependIcon: String,
    iconColor: {
      type: String,
      default: 'gray'
    },
    width: {
      type: String,
      default: '400px'
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/common/util/CardToolTip.vue